import { render, staticRenderFns } from "./ProgramProgramModuleList.vue?vue&type=template&id=7fa4a0de&scoped=true"
import script from "./ProgramProgramModuleList.vue?vue&type=script&lang=js"
export * from "./ProgramProgramModuleList.vue?vue&type=script&lang=js"
import style0 from "./ProgramProgramModuleList.vue?vue&type=style&index=0&id=7fa4a0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa4a0de",
  null
  
)

export default component.exports